import { render, staticRenderFns } from "./Dependientes.vue?vue&type=template&id=3ebd9ac2&scoped=true&lang=html&"
import script from "./Dependientes.vue?vue&type=script&lang=js&"
export * from "./Dependientes.vue?vue&type=script&lang=js&"
import style0 from "./Dependientes.vue?vue&type=style&index=0&id=3ebd9ac2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd9ac2",
  null
  
)

export default component.exports